import {API_DRIVER} from "../configs/axios";

const SimService = {
  fetchAttive: (query, cancelToken, listaDiNumeri) => {
    return API_DRIVER.post(`/api/sim/attive${query}`, listaDiNumeri, {
      cancelToken: cancelToken,
    });
  },
  fetchDaAttivare: (query, cancelToken, listaDiNumeri) => {
    return API_DRIVER.post(`/api/sim/daAttivare${query}`, listaDiNumeri, {
      cancelToken: cancelToken,
    });
  },
  fetchInAttivazione: (query, cancelToken, listaDiNumeri) => {
    return API_DRIVER.post(`/api/sim/inAttivazione${query}`, listaDiNumeri, {
      cancelToken: cancelToken,
    });
  },
  fetchSospese: (query, cancelToken, listaDiNumeri) => {
    return API_DRIVER.post(`/api/sim/sospese${query}`, listaDiNumeri, {
      cancelToken: cancelToken,
    });
  },
  fetchSostitutive: (query, cancelToken, listaDiNumeri) => {
    return API_DRIVER.post(`/api/sim/sostitutive${query}`, listaDiNumeri, {
      cancelToken: cancelToken,
    });
  },
  fetchNumeriBloccatti: (body) => {
    return API_DRIVER.post(`/api/sim/numeriBloccatti`, body);
  },
  fetchSchedaTecnica: (seriale, selectedCompanyCode, uid) => {
    return API_DRIVER.get(
        `/api/sim/schedaTecnica/${seriale}/customer/${selectedCompanyCode}/uid/${uid}`
    );
  },
  fetchOfferta: (seriale, tipologia, integrationId) => {
    return API_DRIVER.get(
        `/api/sim/offerta/${seriale}/tipologia/${tipologia}/customer/${integrationId}`
    );
  },
  downloadCsvFromOrder: (orderId, integrationId) => {
    return API_DRIVER(
        `/api/sim/order/csv/${orderId}/customer/${integrationId}`,
        {
          responseType: "blob",
        }
    );
  },
  fetchWrenchDetails: (body) => {
    return API_DRIVER.post("/api/sim/wrenchDetails", body);
  },
  fetchFilterData: (integrationId, withCollaborators) => {
    return API_DRIVER.get(
        `/api/sim/filter-data?companyId=${integrationId}&withCollaborators=${withCollaborators}`
    );
  },
  fetchFilterSuggestions: (query, cancelToken, listaDiNumeri) => {
    return API_DRIVER.post(`/api/sim/autocomplete${query}`, listaDiNumeri, {
      cancelToken: cancelToken,
    });
  },
  checkWrenchDetails: (body) => {
    return API_DRIVER.post("/api/sim/wrenchDetails", body);
  },
  fetchSostitutiveSimSuggestions: (integrationId, type, iccId) => {
    return API_DRIVER.get(
        `/api/sim/sostitutive/integrationId/${integrationId}`,
        {
          params: {
            iccId,
            type,
          },
        }
    );
  },
  fetchIpAddresses: (fetchIpAddressesDto) => {
    return API_DRIVER.post(
        `/api/sim/change-ip/valid-addresses`,
        fetchIpAddressesDto
    );
  },
  disassociateSimForUser: (integrationId, body) => {
    return API_DRIVER.post(
        `/api/sim/disassociate-sim-from-psu-user/integrationId/${integrationId}`,
        body
    );
  },
  fetchCollaborators: (body, query) => {
    return API_DRIVER.post(`/api/sim/collaborators${query}`, body);
  },
  addCollaborators: (body, query) => {
    return API_DRIVER.post(`/api/sim/addCollaborator${query}`, body);
  },
  fetchEdhDetails: (body, simGroup, cancelToken) => {
    return API_DRIVER.post("/api/sim/details/edh", body, {
      cancelToken: cancelToken,
      params: {
        simGroup,
      },
    });
  },
  fetchOcsDetails: (body, cancelToken) => {
    return API_DRIVER.post("/api/sim/details/ocs", body, {
      cancelToken: cancelToken,
    });
  },
  fetchExtrasDetails: (body, cancelToken) => {
    return API_DRIVER.post("/api/sim/details/extras", body, {
      cancelToken: cancelToken,
    });
  },
  fetchSimGroupCount: (integrationId, simGroup) => {
    return API_DRIVER.get("/api/sim/group-count", {
      params: {
        integrationId,
        simGroup,
      },
    });
  },
  downloadCsv: (selectedSims, query, simGroup, areAllSelected, isMassiveTag, listaDiNumeri) => {
    return API_DRIVER.post(
        `/api/sim/${simGroup}/download-csv${query}&areAllSelected=${areAllSelected}&isMassiveTag=${isMassiveTag}`,
        {
          selectedSims,
          listaDiNumeri
        },
        {
          responseType: "blob",
        }
    );
  },
  fetchSimsToBeRecharged: (integrationId, msisdn, page, size, sort) => {
    return API_DRIVER.get(`/api/sim/attive/gestione-autoricariche`, {
      params: {
        integrationId,
        msisdn,
        page,
        size,
        sort,
      },
    });
  },
  addRechargeProperties: (requestBody) => {
    return API_DRIVER.post(
        `/api/sim/attive/gestione-autoricariche/changeOfferingProperty`,
        requestBody
    );
  },
  fetchESim: (integrationId, iccid) => {
    return API_DRIVER.get(
        `/api/sim/eSim/integrationId/${integrationId}/iccid/${iccid}`
    );
  },
  distribuzioneDigitaleEsim: (
      integrationId,
      emailReferente,
      distribuzioneList,
      password
  ) => {
    return API_DRIVER.post("api/sim/eSim/distribuzione-digitale", {
      integrationId,
      emailReferente,
      distribuzioneList,
      password,
    });
  },
  distribuzioneDigitaleEsimSostitutive: (
      integrationId,
      emailReferente,
      distribuzioneList,
      password
  ) => {
    return API_DRIVER.post("/api/v1/esim/product-change/distributions", {
      integrationId,
      emailReferente,
      distribuzioneList,
      password,
    });
  },
  modifyTrafficShapingStatus: (integrationId, msisdn, body) => {
    return API_DRIVER.put(`api/v2/sim/customers/${integrationId}/sims/${msisdn}/traffic-shaping`, body);
  },
};

export default SimService;
